export default {
	namespaced: true,
	state: {
		menuActivo: {
			evento: null,
			titulo: null,
			style: {},
			items: []
		},
		estaActivo: false
	},

	getters: {
		menu (state) {
			if (!state.estaActivo) {
				return null
			}

			return state.menuActivo
		},
		activo (state) {
			return state.estaActivo
		}
	},

	mutations: {
		mostrar (state, payload) {
			if (!Array.isArray(payload.items) || payload.items.length === 0) {
				return
			}

			if (!payload.evento) {
				return
			}

			// Calculamos estilo
			state.menuActivo.style = {
				top: payload.evento.clientY + 'px',
				left: payload.evento.clientX + 'px'
			}

			state.menuActivo.evento = payload.evento
			state.menuActivo.titulo = (typeof payload.titulo === 'string' && payload.titulo.trim().length > 0) ? payload.titulo : null
			state.menuActivo.items = payload.items.map(item => {
				const a = {}
				if (!item.texto) {
					return null
				}

				if (!item.callback) {
					return null
				}

				a.texto = item.texto
				a.activo = (typeof item.activo === 'boolean') ? item.activo : false
				a.callback = item.callback
				a.icono = (typeof item.icono === 'string' && item.icono.trim().length > 0) ? item.icono : null
				return a
			})

			if (state.menuActivo.items.length === 0) {
				return
			}
			state.estaActivo = true
		},
		cerrar (state) {
			state.estaActivo = false
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/contextual.js